import { styled } from '@mui/material/styles';
import { Box, Tab, Tabs } from '@mui/material';
import { color } from 'framer-motion';

// 출석/예약 탭 컨테이너 — 흰 배경 + 라운드 코너로 본문 영역을 카드처럼 감쌈.
export const PageContainer = styled(Box)({
  width: '100%',
  background: '#fff',
  borderRadius: '5px',
});

// 개인 레슨 / 그룹 레슨 / 입장 내역 sub-tab.
// indicator는 굵은 teal 라인으로 강조 (회사 톤과 동일한 #4AB3BC).
export const SubTabsBar = styled(Tabs)({
  '& .MuiTabs-indicator': {
    height: '5px',
    background: '#4AB3BC',
    borderRadius: '5px',
  },
});

export const SubTab = styled(Tab)({
  fontSize: '18px',
  fontWeight: 600,
  textTransform: 'none',
});
